import { useObserver } from 'mobx-react-lite';
import useStores from 'shared/hooks/use-stores';

export default function useCart() {
  const stores = useStores();
  return useObserver(() => stores.Cart);
}
